import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { UserService } from '@big-direkt/state/user';
import { UiButtonComponent } from '@big-direkt/ui/button';
import { UiLinkComponent } from '@big-direkt/ui/link';
import { IconBigBoldWinkelLinks, IconBigBoldWinkelRechts, IconComponent } from '@big-direkt/utils/icons';
import { BreakpointService, MenuItemModel } from '@big-direkt/utils/shared';
import { TranslocoDirective } from '@jsverse/transloco';
import { NavService } from '../../services/nav.service';
import { PopoverService } from '../../services/popover.service';
import { SidenavService } from '../../services/sidenav.service';
import { NavQuicknavComponent } from '../nav-quicknav/nav-quicknav.component';

@Component({
    selector: 'big-nav-main-mobile',
    templateUrl: './nav-main-mobile.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NavQuicknavComponent, UiLinkComponent, IconComponent, UiButtonComponent, TranslocoDirective],
})
export class NavMainMobileComponent {
    public readonly navService = inject(NavService);
    public readonly sidenavService = inject(SidenavService);
    public readonly breakpointService = inject(BreakpointService);
    private readonly userService = inject(UserService);
    private readonly popoverService = inject(PopoverService);
    public readonly isLoggedIn = this.userService.isAuthenticated;
    public readonly isMobile = this.breakpointService.isMobile;
    public readonly iconAngleRight = IconBigBoldWinkelRechts;
    public readonly iconAngleLeft = IconBigBoldWinkelLinks;
    public readonly subnavItem = signal<MenuItemModel | undefined>(undefined);

    public openSubnav(item: MenuItemModel): void {
        if (this.isMobile()) {
            this.sidenavService.openSubnav(item);
        } else {
            this.subnavItem.set(item);
        }
    }

    public closeSubnav(): void {
        if (this.isMobile()) {
            this.sidenavService.closeSubnav();
        } else {
            this.subnavItem.set(undefined);
        }
    }

    public onNavItemSelected(): void {
        if (this.isMobile()) {
            this.sidenavService.closeSidenav();
        } else {
            this.popoverService.closeCurrent();
        }
    }
}
